import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

    public navData: any[];

    constructor() {
    }

    ngOnInit(): void {
        this.navData = [
            {
                title: $localize`Prices`,
                children: [
                    {
                        title: $localize`Price Groups`,
                        url: ['/', 'settings', {outlets: {settings_outlet: ['price-groups']}}]
                    },
                    {
                        title: $localize`Price Adjustments`,
                        url: ['/', 'settings', {outlets: {settings_outlet: ['price-adjustments']}}]
                    }
                ]
            },
            {
                title: $localize`Contact`,
                children: [
                    {
                        title: $localize`Contact fields`,
                        url: ['/', 'settings', {outlets: {settings_outlet: ['contact-fields']}}]
                    },
                    {
                        title: $localize`Contact field presets`,
                        url: ['/', 'settings', {outlets: {settings_outlet: ['contact-field-presets']}}]
                    },
                    {
                        title: $localize`Contact types`,
                        url: ['/', 'settings', {outlets: {settings_outlet: ['contact-types']}}]
                    }
                ]
            },
            {
                title: $localize`Products`,
                children: [
                    {
                        title: $localize`Products`,
                        url: ['/', 'settings', {outlets: {settings_outlet: ['products']}}]
                    },
                    {
                        title: $localize`Product categories`,
                        url: ['/', 'settings', {outlets: {settings_outlet: ['product-categories']}}]
                    },
                    {
                        title: $localize`Product fields`,
                        url: ['/', 'settings', {outlets: {settings_outlet: ['product-fields']}}]
                    },
                    {
                        title: $localize`Product field presets`,
                        url: ['/', 'settings', {outlets: {settings_outlet: ['product-field-presets']}}]
                    },
                    {
                        title: $localize`Import products`,
                        url: ['/', 'settings', {outlets: {settings_outlet: ['products', 'import']}}]
                    }
                ]
            },
            {
                title: $localize`Orders`,
                children: [
                    {
                        title: $localize`Order fields`,
                        url: ['/', 'settings', {outlets: {settings_outlet: ['order-fields']}}]
                    },
                    {
                        title: $localize`Order line fields`,
                        url: ['/', 'settings', {outlets: {settings_outlet: ['order-line-fields']}}]
                    }
                ]
            },
            {
                title: $localize`VAT types`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['vat-types']}}]
            },
            {
                title: $localize`Units`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['units']}}]
            },
            {
                title: $localize`Payment agreements`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['payment-agreements']}}]
            },
            {
                title: $localize`References`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['references']}}]
            },
            {
                title: $localize`Dates`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['dates']}}]
            },
            {
                title: $localize`Order types`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['order-types']}}]
            },
            {
                title: $localize`Order states`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['order-states']}}]
            },
            {
                title: $localize`Branches`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['branches']}}]
            },
            {
                title: $localize`User`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['user']}}]
            },
            {
                title: $localize`Users`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['users']}}]
            },
            {
                title: $localize`Groups`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['groups']}}]
            },
            {
                title: $localize`Audit log`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['audit-log']}}]
            },
            {
                title: $localize`Attachments`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['attachments']}}]
            },
            {
                title: $localize`Articles`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['articles']}}]
            },
            {
                title: $localize`Currencies`,
                url: ['/', 'settings', {outlets: {settings_outlet: ['currencies']}}]
            },
        ];
    }
}
